









import { Vue, Component } from 'vue-property-decorator';
import { getBaseInfo } from './api';
import { isWeiXin } from '@/common/ts/common';

@Component
export default class ViewHolder extends Vue {
  baseInfo: any = {};
  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    this.$addPv(this.baseInfo.activityId);
    this.$appShareInfo({
      title: '2020重庆青少年击剑锦标赛',
      url: location.href,
      subtitle: '',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2020重庆青少年击剑锦标赛',
        subtitle: '',
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      });
    }
  }
}
